// @flow

import { makeApiCall } from '../../../../services/apiService/apiService';
import { minimumClientSearchCharacterLength } from '../../../../services/helpers';
import { toastr } from 'react-redux-toastr';

export const servicePerformanceActions = {
  SET_IS_FETCHING_CLIENT_LIST: 'SET_IS_FETCHING_CLIENT_LIST',
  SET_CLIENT_LIST: 'SET_CLIENT_LIST',
  RESET_CLIENT_LIST_AND_FETCHING: 'RESET_CLIENT_LIST_AND_FETCHING',
  SET_CHARTS_DATA: 'SET_CHARTS_DATA',
  RESET_CHARTS_DATA_AND_FETCHING: 'RESET_CHARTS_DATA_AND_FETCHING',
  SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
  SET_NSL_SERVICE_DATA: 'SET_NSL_SERVICE_DATA',
  SET_NSL_BREAKUP_DATA: 'SET_NSL_BREAKUP_DATA',
  SET_NSL_ERROR_MESSAGE: ' SET_NSL_ERROR_MESSAGE',
  SET_NSL_SERVICE_ERROR_MESSAGE: 'SET_NSL_SERVICE_ERROR_MESSAGE',
  SET_NSL_BREAKUP_ERROR_MESSAGE: 'SET_NSL_BREAKUP_ERROR_MESSAGE',
  SET_BUSINESS_OVERVIEW_DATA: 'SET_BUSINESS_OVERVIEW_DATA',
  SET_BUSINESS_OVERVIEW_ERROR_MESSAGE: 'SET_BUSINESS_OVERVIEW_ERROR_MESSAGE',
  SET_RP_CLIENT_LIST: 'SET_RP_CLIENT_LIST',
  RESET_RP_CLIENT_LIST: 'RESET_RP_CLIENT_LIST',
  SET_IS_FETCHING_NSL_BREAKUP_DATA: 'SET_IS_FETCHING_NSL_BREAKUP_DATA',
  SET_IS_FETCHING_NET_SERVICE_LEVEL_DATA:
    'SET_IS_FETCHING_NET_SERVICE_LEVEL_DATA',
  SET_IS_FETCHING_BUSINESS_OVERVIEW_DATA:
    'SET_IS_FETCHING_BUSINESS_OVERVIEW_DATA'
};

export const setIsFetchingNslBreakupData = load => ({
  type: servicePerformanceActions.SET_IS_FETCHING_NSL_BREAKUP_DATA,
  payload: load
});

export const setIsFetchingNetServiceLevelData = load => ({
  type: servicePerformanceActions.SET_IS_FETCHING_NET_SERVICE_LEVEL_DATA,
  payload: load
});

export const setIsFetchingBusinessOverviewData = load => ({
  type: servicePerformanceActions.SET_IS_FETCHING_BUSINESS_OVERVIEW_DATA,
  payload: load
});

export const setIsFetchingClientList = load => ({
  type: servicePerformanceActions.SET_IS_FETCHING_CLIENT_LIST,
  payload: load
});

const setNslServiceData = load => ({
  type: servicePerformanceActions.SET_NSL_SERVICE_DATA,
  payload: load
});

const setNslBreakupData = load => ({
  type: servicePerformanceActions.SET_NSL_BREAKUP_DATA,
  payload: load
});

const setBusinessOverviewData = load => ({
  type: servicePerformanceActions.SET_BUSINESS_OVERVIEW_DATA,
  payload: load
});

export const setClientList = load => ({
  type: servicePerformanceActions.SET_CLIENT_LIST,
  payload: load
});

export const setRPClientsList = load => ({
  type: servicePerformanceActions.SET_RP_CLIENT_LIST,
  payload: load
});

export const resetRPClientsList = () => ({
  type: servicePerformanceActions.RESET_RP_CLIENTS_LIST
});

export const resetChartsDataAndFetching = () => ({
  type: servicePerformanceActions.RESET_CHARTS_DATA_AND_FETCHING
});

export const resetClientListAndIsFetching = () => ({
  type: servicePerformanceActions.RESET_CLIENT_LIST_AND_FETCHING
});

const setNslErrorMessage = load => ({
  type: servicePerformanceActions.SET_NSL_SERVICE_ERROR_MESSAGE,
  payload: load
});

const setNslBreakupErrorMessage = load => ({
  type: servicePerformanceActions.SET_NSL_BREAKUP_ERROR_MESSAGE,
  payload: load
});

const setBusinessOverviewErrorMessage = load => ({
  type: servicePerformanceActions.SET_BUSINESS_OVERVIEW_ERROR_MESSAGE,
  payload: load
});

export const getClientsList = (apiToUse, userId) => (dispatch: Function) => {
  dispatch(setIsFetchingClientList(true));

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: apiToUse,

    replaceParamsArr:
      apiToUse === 'getClientsById'
        ? [
            {
              key: 'userId',
              val: userId
            },
            {
              key: 'status',
              val: 'ACTIVE'
            }
          ]
        : null,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(setIsFetchingClientList(false));
        const responseList = res.payload || [];
        dispatch(setClientList(responseList));
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getClients call 200 failure', res);
        dispatch(resetClientListAndIsFetching());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getClients call failed ', res);
      dispatch(resetClientListAndIsFetching());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getClients call', res);
      dispatch(resetClientListAndIsFetching());
    }
  };

  return makeApiCall(requestObj);
};

const getBusinessOverViewData = (
  orgCodes,
  clientCodes,
  retailPartnerUserIds,
  intervalType,
  startDate,
  endDate
) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getChartsDataBusinessOverView',
    replaceParamsArr: [
      {
        key: 'orgCodes',
        val: orgCodes
      },
      {
        key: 'clientCodes',
        val: clientCodes
      },
      {
        key: 'intervalType',
        val: intervalType
      },
      {
        key: 'startDate',
        val: startDate
      },
      {
        key: 'endDate',
        val: endDate
      },
      {
        key: 'retailPartnerUserIds',
        val: retailPartnerUserIds
      }
    ]
  };

  return makeApiCall(requestObj);
};

const getNslServiceData = (
  orgCodes,
  clientCodes,
  retailPartnerUserIds,
  intervalType,
  startDate,
  endDate
) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getChartsDataNsl',
    replaceParamsArr: [
      {
        key: 'orgCodes',
        val: orgCodes
      },
      {
        key: 'clientCodes',
        val: clientCodes
      },
      {
        key: 'intervalType',
        val: intervalType
      },
      {
        key: 'startDate',
        val: startDate
      },
      {
        key: 'endDate',
        val: endDate
      },
      {
        key: 'retailPartnerUserIds',
        val: retailPartnerUserIds
      }
    ]
  };

  return makeApiCall(requestObj);
};

const getNslBreakupData = (
  orgCodes,
  clientCodes,
  retailPartnerUserIds,
  intervalType,
  startDate,
  endDate
) => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getChartsDataNslBreakup',
    replaceParamsArr: [
      {
        key: 'orgCodes',
        val: orgCodes
      },
      {
        key: 'clientCodes',
        val: clientCodes
      },
      {
        key: 'intervalType',
        val: intervalType
      },
      {
        key: 'startDate',
        val: startDate
      },
      {
        key: 'endDate',
        val: endDate
      },
      {
        key: 'retailPartnerUserIds',
        val: retailPartnerUserIds
      }
    ]
  };

  return makeApiCall(requestObj);
};

export const getChartsData = (
  orgCodes,
  clientCodes,
  retailPartnerUserIds,
  intervalType,
  startDate,
  endDate
) => (dispatch: Function) => {
  dispatch(resetChartsDataAndFetching());
  dispatch(setIsFetchingNslBreakupData(true));
  dispatch(setIsFetchingNetServiceLevelData(true));
  dispatch(setIsFetchingBusinessOverviewData(true));
  dispatch(setNslBreakupData({}));
  dispatch(setBusinessOverviewData({}));
  dispatch(setNslServiceData({}));

  const nslServicePromise = getNslServiceData(
    orgCodes,
    clientCodes,
    retailPartnerUserIds,
    intervalType,
    startDate,
    endDate
  );
  const NslBreakupPromise = getNslBreakupData(
    orgCodes,
    clientCodes,
    retailPartnerUserIds,
    intervalType,
    startDate,
    endDate
  );
  const businessOverViewPromise = getBusinessOverViewData(
    orgCodes,
    clientCodes,
    retailPartnerUserIds,
    intervalType,
    startDate,
    endDate
  );

  nslServicePromise
    .then(response => {
      dispatch(setIsFetchingNetServiceLevelData(false));
      if (response.status === 'SUCCESS') {
        dispatch(setNslServiceData(response.payload));
      } else {
        dispatch(setNslErrorMessage({ errorMessage: response.errorMessage }));
      }
    })
    .catch(err => {
      console.log(err);
    });

  NslBreakupPromise.then(response => {
    dispatch(setIsFetchingNslBreakupData(false));
    if (response.status === 'SUCCESS') {
      dispatch(setNslBreakupData(response.payload));
    } else {
      dispatch(
        setNslBreakupErrorMessage({ errorMessage: response.errorMessage })
      );
    }
  }).catch(err => {
    console.log(err);
  });

  businessOverViewPromise
    .then(response => {
      dispatch(setIsFetchingBusinessOverviewData(false));
      if (response.status === 'SUCCESS') {
        dispatch(setBusinessOverviewData(response.payload));
      } else {
        dispatch(
          setBusinessOverviewErrorMessage({
            errorMessage: response.errorMessage
          })
        );
      }
    })
    .catch(err => {
      console.log(err);
    });

  /*Promise.all([nslServicePromise, NslBreakupPromise, businessOverViewPromise])
    .then(values => {
      dispatch(setIsFetchingChartsData(false));
      if (values.length > 0) {
        if (values[0].status === 'SUCCESS') {
          dispatch(setNslServiceData(values[0].payload));
        } else {
          dispatch(
            setNslErrorMessage({ errorMessage: values[0].errorMessage })
          );
        }
      }

      if (values.length > 1) {
        if (values[1].status === 'SUCCESS') {
          dispatch(setNslBreakupData(values[1].payload));
        } else {
          dispatch(
            setNslBreakupErrorMessage({ errorMessage: values[1].errorMessage })
          );
        }
      }

      if (values.length > 2) {
        if (values[2].status === 'SUCCESS') {
          dispatch(setBusinessOverviewData(values[2].payload));
        } else {
          dispatch(
            setBusinessOverviewErrorMessage({
              errorMessage: values[2].errorMessage
            })
          );
        }
      }
    })
    .catch(err => {
      console.log(err);
    });*/
};

export const getRPClientsList = () => (dispatch: Function) => {
  dispatch(setIsFetchingClientList(true));

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getRPClientList',
    replaceParamsArr: [
      { key: 'operationalStatus', val: 'ACTIVE' },
      {
        key: 'availabilityStatus',
        val: 'AVAILABLE'
      },
      {
        key: 'stockAccumulatorRole',
        val: 'STOCK_ACCUMULATOR_ADMIN'
      }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(setIsFetchingClientList(false));
        const responseList = res.payload || [];
        dispatch(setRPClientsList(responseList));
      } else if (res.status === 'FAILURE') {
        // eslint-disable-next-line no-console
        console.log('getRPClientList call 200 failure', res);
        dispatch(resetRPClientsList());
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getRPClientList call failed ', res);
      dispatch(resetRPClientsList());
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getRPClientList call', res);
      dispatch(resetRPClientsList());
    }
  };

  return makeApiCall(requestObj);
};
